<template>
  <div class="_request-form">
    <b-row class="m-0">
      <!-- Form-->
      <b-col lg="12" class="d-flex align-items-center px-2 p-lg-5 mt-2">
        <b-col sm="12" md="8" lg="6" class="px-xl-2 mx-auto">
          <b-card>
            <b-card-title
              class="mb-1 font-weight-bold text-center"
              title-tag="h2"
            >
              Olá, bem-vindo(a)!
            </b-card-title>
            <b-card-text class="mb-2" v-if="!headerDescription">
              Este formulário foi construído para você solicitar seus direitos
              em relação aos seus dados pessoais.<br /><br />
            </b-card-text>
            <b-card-text
              class="mb-2"
              v-if="headerDescription"
              v-html-safe="headerDescription"
            >
            </b-card-text>
            <!-- form -->
            <validation-observer ref="requestForm">
              <b-form class="mb-1 mt-2" @submit.prevent="send">
                <!-- Request -->
                <b-form-group label="Solicitante" label-for="request_type">
                  <validation-provider
                    #default="{ errors }"
                    name="Solicitante"
                    rules="required"
                  >
                    <b-form-radio-group
                      v-model="requestType"
                      :options="requestTypeList"
                      name="request_type"
                      stacked
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- Bond Type -->
                <b-form-group
                  label="Natureza do vínculo"
                  label-for="request_bond_type"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Natureza do vínculo"
                    rules="required"
                  >
                    <b-form-radio-group
                      v-model="requestBondTypeId"
                      :options="requestBondTypeList"
                      value-field="id"
                      text-field="name"
                      name="request_bond_type"
                      stacked
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- Legal Person -->
                <b-form-group label="Unidade" label-for="legal_person">
                  <validation-provider
                    #default="{ errors }"
                    name="Unidade"
                    rules="required"
                  >
                    <v-select
                      v-model="legalEntity"
                      :options="listLegal"
                      label="name"
                      class="required-select"
                    >
                      <div slot="no-options">Nenhum registro encontrado!</div>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- Category -->
                <b-form-group label="Solicitação" label-for="request_category">
                  <validation-provider
                    #default="{ errors }"
                    name="Solicitação"
                    rules="required"
                  >
                    <v-select
                      :clearable="true"
                      multiple
                      dir="ltr"
                      deselect-from-dropdown
                      v-model="requestCategory"
                      :options="requestCategoryList"
                      label="name"
                      class="required-select multiple"
                    >
                      <!-- Hotfix Multiple wont remove selection if we dont implement it manually like this -->
                      <template
                        v-slot:selected-option-container="{
                          option,
                          deselect,
                          multiple,
                          disabled,
                        }"
                      >
                        <div
                          v-b-tooltip.hover
                          :title="option.description"
                          class="flex flex-row items-center"
                        >
                          <div class="vs__selected">{{ option.name }}</div>
                          <div>
                            <feather-icon
                              class="cursor-pointer h-5 w-5"
                              @click.stop="
                                () => removeCategorySelect(option.id)
                              "
                              icon="XIcon"
                              size="12"
                            />
                          </div>
                        </div>
                      </template>
                      <div slot="no-options">Nenhum registro encontrado!</div>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- Name -->
                <b-form-group label="Nome" label-for="person_name">
                  <validation-provider
                    #default="{ errors }"
                    name="Nome"
                    rules="required"
                  >
                    <b-form-input
                      id="person_name"
                      v-model="personName"
                      :state="errors.length > 0 ? false : null"
                      name="person_name"
                      class="required"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <div v-if="!isAnpd">
                  <!-- Document -->
                  <div class="flex flex-row flex-wrap gap-1">
                    <label class="flex-grow w-full text-sm">Documento</label>
                    <div class="flex items-center pb-1 select-none">
                      <label
                        :class="[
                          isCpf ? 'text-primary font-bold' : '',
                          'mb-0 pr-1',
                        ]"
                        >CPF</label
                      >
                      <b-form-checkbox
                        v-model="isCpf"
                        class="custom-control-secondary"
                        name="check-button"
                        switch
                      />
                      <label
                        :class="[
                          isCpf ? '' : 'text-primary font-bold',
                          'mb-0 ',
                        ]"
                        >CRNM (RNE)</label
                      >
                    </div>
                  </div>
                  <b-form-group label-for="person_document" v-if="isCpf">
                    <validation-provider
                      #default="{ errors }"
                      name="CPF"
                      rules="required|cpf"
                    >
                      <b-form-input
                        id="person_document"
                        v-model="personDocument"
                        :state="errors.length > 0 ? false : null"
                        name="person_document"
                        v-mask="'###.###.###-##'"
                        class="required"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group label-for="person_document" v-else>
                    <validation-provider
                      #default="{ errors }"
                      name="CRNM (RNE)"
                      rules="required"
                    >
                      <b-form-input
                        id="person_document"
                        v-model="personDocument"
                        :state="errors.length > 0 ? false : null"
                        name="person_document"
                        v-mask="'X'.repeat(32)"
                        class="required"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>

                <!--
                <b-form-group
                  label="CPF"
                  label-for="person_document" v-if="!isAnpd">
                  <validation-provider
                      #default="{ errors }"
                      name="CPF"
                      rules="required|cpf">
                      <b-form-input
                        id="person_document"
                        v-model="personDocument"
                        :state="errors.length > 0 ? false:null"
                        name="person_document"
                        v-mask="'###.###.###-##'"
                        class="required"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                -->
                <b-form-group
                  label="CNPJ"
                  label-for="person_document"
                  v-if="isAnpd"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="CNPJ"
                    rules="required|cnpj"
                  >
                    <b-form-input
                      id="person_document"
                      v-model="personDocument"
                      :state="errors.length > 0 ? false : null"
                      name="person_document"
                      v-mask="'##.###.###/####-##'"
                      class="required"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- Birth Date -->
                <b-form-group
                  label="Data Nascimento"
                  label-for="birth_date"
                  v-if="!isAnpd"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Data Nascimento"
                    rules="required">
                    <flat-pickr
                        v-model="birth_date"
                        class="form-control"
                        :config="configCalendar"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- email -->
                <b-form-group label="Email" label-for="email">
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    vid="email"
                    rules="required|email"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="email"
                        v-model="personEmail"
                        :state="errors.length > 0 ? false : null"
                        name="email"
                        placeholder="joao@exemplo.com"
                        class="required"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- Phone -->
                <b-form-group label="Telefone" label-for="person_phone">
                  <validation-provider
                    #default="{ errors }"
                    name="Telefone"
                    rules="required"
                  >
                    <b-form-input
                      id="person_document"
                      v-model="personPhone"
                      :state="errors.length > 0 ? false : null"
                      name="person_phone"
                      v-mask="['(##)####-####', '(##)#####-####']"
                      class="required"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- Country -->
                <b-form-group label="País" label-for="country">
                  <validation-provider
                    #default="{ errors }"
                    name="País"
                    rules="required"
                  >
                    <v-select
                      v-model="country"
                      :options="countryList"
                      label="name_pt"
                      class="required-select"
                    >
                      <div slot="no-options">Nenhum registro encontrado!</div>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- description -->
                <b-form-group
                  :label="$t('privacy_form_description')"
                  label-for="description"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Descrição da solicitação"
                    rules="min:10|max:65535"
                  >
                    <b-form-textarea
                      id="description"
                      v-model="description"
                      :state="errors.length ? false : null"
                      :placeholder="$t('privacy_form_min_caracter')"
                      rows="4"
                      maxlength="65535"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <div class="vx-row pt-2 justify-content-center">
                  <div class="vx-col">
                    <vue-dropzone
                      id="upload"
                      ref="fileUploadZone"
                      v-on:vdropzone-success="successSendFormWithFile"
                      v-on:vdropzone-sending="sendFormWithFile"
                      v-on:vdropzone-error="error"
                      v-on:vdropzone-file-added="added"
                      v-on:vdropzone-queue-complete="complete"
                      :use-font-awesome="true"
                      :options="dropzoneOptions"
                      :use-custom-dropzone-options="true"
                      :validation-allowed-extensions="['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png']"
                      :useCustomSlot="true"
                      @vdropzone-file-added="fileAdded"
                    >
                      <div class="dropzone-custom-content">
                        Arraste e solte para enviar um arquivo
                        <p class="separator">
                          <span class="separator-span"> ou </span>
                        </p>
                        <b-button
                          type="button"
                          class="btn waves-effect outline-primary"
                          variant="outline-secondary"
                          >Selecionar</b-button
                        >
                      </div>
                    </vue-dropzone>
                  </div>
                </div>
                <!-- submit buttons -->
                <div class="vx-row pt-2">
                  <div class="vx-col w-full">
                    <b-button
                      type="submit"
                      variant="primary"
                      class="waves-effect float-right"
                    >
                      Enviar
                      <!--:disabled="!validateForm"-->
                    </b-button>
                  </div>
                </div>
              </b-form>
            </validation-observer>
            <!-- end form-->
            <b-card-footer class="text-right">
              <small class="text-muted">Desenvolvido por:</small> &nbsp;&nbsp;
              <b-link href="https://securamdata.com" target="_brank"
                >securamdata.com</b-link
              >
            </b-card-footer>
          </b-card>
        </b-col>
        <!-- b-col-->
      </b-col>
    </b-row>
    <b-modal
      width="550px"
      v-model="activeDialogAge"
      title="Procotolo"
      ok-only
      centered
    >
      <div class="con-content">
        <p>
          {{ protocolNumber }}
        </p>
        <p v-html="msgDescription"></p>
        <p>
          Link Portal Privacidade:
          <a :href="linkPrivacy" target="_blank" rel="privacy">{{
            linkPrivacy
          }}</a>
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadioGroup,
  BFormTextarea,
  BCard,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { ptBR } from 'educatena-vuejs-datepicker/dist/locale'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import standard from '@/services/standard'

import CountryService from '@/services/api/CountryService'
import RequestCategoryFormService from '@/services/api/RequestCategoryFormService'
import RequestBondTypeService from '@/services/api/RequestBondTypeService'
import RequestFormLgpdService from '@/services/api/RequestFormLgpdService'
import EduStateRadio from '@/components/EduStateRadio.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BFormRadioGroup,
    BFormTextarea,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    flatPickr,
    vueDropzone: vue2Dropzone,
    EduStateRadio,
  },
  props: {
    param_encrypt: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      format: 'dd/MM/yyyy',
      ptBR,
      legalEntityId: '', //Get param encrypt
      headerDescription: '',
      msgDescription: '',
      linkPrivacy: '',
      requestType: '',
      legalEntity: '',
      requestCategory: [],
      requestBondTypeId: '',
      personName: '',
      personDocument: '',
      birth_date: '',
      personEmail: '',
      personPhone: '',
      country: '',
      description: '',
      isCpf: true,
      //
      activeDialogAge: false,
      protocolNumber: '',
      //
      requestTypeList: [
        { text: 'Titular', value: 'TI' },
        { text: 'Representante', value: 'RE' },
        { text: 'ANPD', value: 'AN' },
      ],
      legalEntityList: [],
      requestCategoryList: [],
      requestBondTypeList: [],
      countryList: [],
      // validation rules
      required,
      email,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_BASE_URL}/api/v1/request_form_lgpd`,
        addRemoveLinks: true,
        autoProcessQueue: false,
        thumbnailWidth: 200,
        maxFiles: 1,
        createImageThumbnails: true,
        acceptedFiles:
          'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg,image/png',
        dictInvalidFileType:
          'Arquivos permitidos: PDF, Word (.doc, .docx) e imagens (.jpg, .jpeg, .png)',
        dictRemoveFile: 'Remover arquivo',
      },
      services: {
        countryService: null,
        legalEntitySponsorService: null,
        requestCategoryFormService: null,
        requestFormLgpdService: null,
      },
    }
  },
  watch: {
    requestType() {
      this.$nextTick(() => {
        this.personDocument = ''
        this.clearErrors(this.$validator)
      })
    },
  },
  computed: {
    validateForm() {
      return (
        !this.isEmpty(this.requestType) &&
        !this.isEmpty(this.legalEntity) &&
        !this.isEmpty(this.personDocument) &&
        !this.isEmpty(this.requestCategory) &&
        !this.isEmpty(this.requestBondTypeId) &&
        !this.isEmpty(this.personName) &&
        !this.isEmpty(this.personEmail) &&
        !this.isEmpty(this.personPhone) &&
        !this.isEmpty(this.country) &&
        !this.isEmpty(this.birth_date)
      )
    },
    isAnpd() {
      return !this.isEmpty(this.requestType) && this.requestType === 'AN'
    },
    listLegal() {
      this.legalEntityList.push({
        id: null,
        name: 'Outras',
        trading_name: 'Outras',
      })
      return this.legalEntityList
    },
    getLocale() {
      return this.$i18n.locale
    },
    configCalendar() {
      return {
        wrap: true,
        enableTime: false,
        allowInput: true,
        ariaDateFormat: 'DD/MM/YYYY',
        dateFormat: "DD/MM/YYYY",
        altFormat: "DD/MM/YYYY",
        allowInput: true,
        parseDate: (datestr, format) => {
          return this.$moment(datestr, format, true).toDate();
        },
        formatDate: (date, format, locale) => {
          // locale can also be used
          return this.$moment(date).format(format);
        },
        locale: require(`flatpickr/dist/l10n/${this.getLocale}.js`).default[this.getLocale]
      }
    },
  },
  methods: {
    fileAdded(file) {
      //console.log(file)
      //this.fileUpload = file;
    },
    removeCategorySelect(id) {
      const index = this.requestCategory.findIndex(
        (category) => category.id === id
      )
      this.requestCategory.splice(index, 1)
    },
    send() {
      this.$refs.requestForm.validate().then((success) => {
        if (success) {
          this.clearErrors(this.$refs.requestForm)
          this.$vs.loading()

          const lengthFile = this.$refs.fileUploadZone.getQueuedFiles().length
          if (lengthFile > 0) {
            this.$refs.fileUploadZone.processQueue()
          } else {
            this.sendForm()
          }
        } else {
          console.log('error!', success)
          this.errorAlertFormValidaded()
        }
      })
    },
    sendForm() {
      const params = this.getDataFields()
      this.services.requestFormLgpdService.createOrUpdate(params).then(
        (data) => {
          this.successSend(data)
        },
        (error) => {
          this.$vs.loading.close()
          this.showErrors(this.$refs.requestForm, error)
        }
      )
    },
    sendFormWithFile(file, xhr, formData) {
      let data = _.transform(
        this.getDataFields(),
        (form, value, field) => {
          if (!this._.isEmpty(value) || this._.isNumber(value)) {
            formData.append(field, value)
          }
        },
        new FormData()
      )
      //console.log(formData);
    },
    successSendFormWithFile(file, data) {
      this.successSend(data)
      //remove file trash
      this.$refs.fileUploadZone.removeAllFiles()
    },
    successSend(data) {
      this.$vs.loading.close()
      this.clearFields()
      this.sucessAlertPrococol(data)
    },
    getDataFields() {
      const params = {
        data_encrypt: this.param_encrypt, //TODO get from URl
        request_type: this.requestType,
        document_number: this.personDocument,
        name: this.personName,
        email: this.personEmail,
        phone: this.personPhone,
        request_category_selection: _.map(this.requestCategory, 'id'),
        request_bond_type_id: this.requestBondTypeId,
        legal_entity_id: this.legalEntity.id,
        country_id: this.country.id,
        description: this.description,
        birth_date: this.birth_date? this.$moment(this.birth_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
      }
      return params
    },
    clearFields() {
      ;(this.requestType = ''),
        (this.requestBondTypeId = ''),
        (this.legalEntity = ''),
        (this.requestCategory = []),
        (this.personName = ''),
        (this.personDocument = ''),
        (this.personEmail = ''),
        (this.personPhone = ''),
        (this.country = ''),
        (this.birth_date = null),
        (this.description = ''),
        this.$nextTick(() => {
          this.clearErrors(this.$validator)
        })
    },
    sucessAlertPrococol(data) {
      this.notifySuccess(this.$vs, 'Formulário enviado com sucesso!', 3000)

      let msg = `Suas informações foram registradas, seu número de protocolo é o ${data.protocol_number}. Você receberá uma cópia das informações no e-mail informado.`
      //Capabilite
      if (_.get(data, 'request_type') != 'AN' && _.get(data, 'age') < 18) {
        this.activeDialogAge = true
        this.protocolNumber = msg
        //this.linkPrivacy
      } else {
        this.$vs.dialog({
          type: 'alert',
          color: 'success',
          title: 'Procotolo',
          acceptText: 'ok',
          text: msg,
          accept: this.clearFields,
        })
      }
    },
    errorAlertFormValidaded() {
      const firstField = this.$el.querySelector('.is-invalid')
      if (firstField) {
        firstField.scrollIntoView()
      }
      this.notifyWarning(
        this.$vs,
        'Preencha corretamente os campos do formulário!',
        3000
      )
    },
  },
  mounted() {
    //console.log(this.param_encrypt)
  },
  beforeMount() {
    this.$vs.loading()
    const promisses = []

    //Services
    this.services.requestCategoryFormService = RequestCategoryFormService.build(
      this.$vs
    )
    this.services.requestBondTypeService = RequestBondTypeService.build(
      this.$vs
    )
    this.services.countryService = CountryService.build(this.$vs)
    this.services.requestFormLgpdService = RequestFormLgpdService.build(
      this.$vs
    )

    promisses.push(
      this.services.requestCategoryFormService.all().then(
        (data) => {
          this.requestCategoryList = data
        },
        (error) => {
          this.$vs.loading.close()
        }
      )
    )

    promisses.push(
      this.services.requestBondTypeService.all().then(
        (data) => {
          this.requestBondTypeList = data
        },
        (error) => {
          this.$vs.loading.close()
        }
      )
    )

    promisses.push(
      this.services.countryService.all().then(
        (data) => {
          this.countryList = data
        },
        (error) => {
          this.$vs.loading.close()
        }
      )
    )

    promisses.push(
      this.services.requestFormLgpdService
        .getListLegalEntity(this.param_encrypt)
        .then(
          (data) => {
            this.legalEntityList = data.list
            this.headerDescription = data.header.privacy_form_description
            this.msgDescription = data.header.privacy_form_message
            this.linkPrivacy = data.header.privacy_form_link
          },
          (error) => {
            this.$vs.loading.close()
          }
        )
    )

    Promise.all(promisses).then(() => {
      this.$vs.loading.close()
    })
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.radio.custom-control {
  margin-top: 5px;
}

.file-selector {
  padding: 55px;
  //font-weight: 600;
  background-color: #f9f9f9;
  color: #4e5b69;
  //z-index: -9;
}
.dropzone-container {
  display: flex;
  flex-direction: column;
  border: 1px dashed #ccc;
  border-radius: 15px;
}
.separator {
  position: relative;
}
.separator:after {
  position: absolute;
  content: '';
  height: 1px;
  width: 200px;
  background: #d8d8d8;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.separator-span {
  position: relative;
  background: #f9f9f9;
  padding: 0 4px;
  z-index: 9;
  font-size: 12px;
  color: #4e5b69;
}
</style>

